import Axios from 'axios'
import {
	MessageBox,
	Message,
	Loading
} from 'element-ui'
import router from '../router/index.js';
import qs from 'qs'
import configHttp from '../../configHttp.js'
const baseurl = configHttp.baseURL
const axios = Axios.create({

})
axios.defaults.timeout = 60000; //响应时间
axios.defaults.baseURL = configHttp.baseURL;

axios.interceptors.response.use((res) => {
	//对响应数据做些事
	if (!res.data.success) {
		return Promise.resolve(res);
	}
	return res;
}, (error) => {
	// return Promise.reject(error);
	if (error.code === 'ECONNABORTED' || error.message === "Network Error" || error.message.includes("timeout")) {
		router.push('/login')
	 }
});
var loadingCount = 0

function closeloading(loading) {
	loadingCount--
	if (loadingCount == 0) {
		loading.close()

	}
}

function showloading(Loading) {
	var loading = Loading.service({
		lock: true,
		text: '疯狂加载中,请稍等',
		background: 'transparent'
	})
	loadingCount++
	return loading
}
export default function request(url, method = 'get', params = {}, auth = true) {
	return new Promise((resolve, reject) => {
		axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
		if (url == 'stamp/detail/import' || url == '/manuscript/generat') {
			axios.defaults.timeout = 300000;
		} else {
			axios.defaults.timeout = 60000;
		}
		var loading = showloading(Loading)
		var token = localStorage.getItem('nstoken');
		if (token != "" & token != null) {
			axios.defaults.headers.common['Authorization'] = token;
		} else {
			if (auth) {
				localStorage.clear()
				router.push('/login');
			}
		}
		if (method == "post") {
			var formData = new FormData();
			for (var i in params) {
				formData.append(i, params[i]);
			}
			axios({
				method: "post",
				url: url,
				headers: {
					"Authorization": token
				},
				data: formData,
			}).then((response) => {
				closeloading(loading)
				if (response.data.msg == "登录已过期" || response.data.code == "2000") {
					localStorage.clear()
					router.push('/login');
				}
				resolve(response);
			}, err => {
				if (err.response.data.msg == "登录已过期" || response.data.code == "2000") {
					closeloading(loading)
					localStorage.clear()
					router.push('/login');
				}
				reject(err);
			})
				.catch((error) => {
					reject(error)
				})
		} else {
			axios.get(url, {
				params: params
			})
				.then(response => {
					closeloading(loading)
					if (response.data.msg == "登录已过期" || response.data.code == "2000") {
						localStorage.clear()
						router.push('/login');
					}

					resolve(response)
				}, err => {
					if (err.response.data.msg == "登录已过期" || response.data.code == "2000") {
						closeloading(loading)
						localStorage.clear()
						router.push('/login');
					}
					reject(err)
				})
				.catch((error) => {
					reject(error)
				})
		}

	})
}
export function requestbody(url, method = 'get', params = {}) {
	axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'
	if (url == 'stamp/detail/import' || url == '/manuscript/generat') {
		axios.defaults.timeout = 300000;
	} else {
		axios.defaults.timeout = 60000;
	}
	return new Promise((resolve, reject) => {
		var loading = showloading(Loading)
		var token = localStorage.getItem('nstoken')
		if (token != "" & token != null) {
			axios.defaults.headers.common['Authorization'] = token;
		} else {
			localStorage.clear()
			router.push('/login');
		}
		if (method == "post") {
			axios.post(url, params)
				.then(response => {
					closeloading(loading)
					if (response.data.msg == "登录已过期" || response.data.code == "2000") {
						localStorage.clear()
						router.push('/login');
					}
					resolve(response);
				}, err => {
					reject(err);
				})
				.catch((error) => {
					reject(error)
				})
		} else {
			axios.get(url, {
				params: params
			})
				.then(response => {
					closeloading(loading)
					if (response.data.msg == "登录已过期" || response.data.code == "2000") {
						localStorage.clear()
						router.push('/login');
					}
					resolve(response)
				}, err => {
					reject(err)
				})
				.catch((error) => {
					reject(error)
				})
		}

	})
}

export function requestBlob(url, method = 'get', params = {}) {
	return new Promise((resolve, reject) => {
	  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
	  axios.defaults.timeout = 60000;
	  
  
	  const loading = showloading(Loading);
	  const token = localStorage.getItem('nstoken');
  
	  if (!token) {
		localStorage.clear();
		router.push('/login');
		return;
	  }
  
	  axios.defaults.headers.common['Authorization'] = token;

  
	  const requestConfig = {
		method,
		url,
		headers: {
		  Authorization: token,
		},
		responseType: 'blob', 
	  };
  
	  if (method === 'post') {
		const formData = new FormData();
		for (const key in params) {
		  formData.append(key, params[key]);
		}
		requestConfig.data = formData;
	  } else {
		requestConfig.params = params;
	  }
  
	  axios(requestConfig)
		.then((res) => {
			closeloading(loading);
			resolve(res.data);
		})
		.catch((error) => {
		  closeloading(loading);
		  // 处理登录过期逻辑
		  if (error.response && (error.response.data.msg === '登录已过期' || error.response.data.code === '2000')) {
			localStorage.clear();
			router.push('/login');
			return;
		  }
		  reject(error);
		});
	});
  }
